import { always, apiFetch } from 'utils'

function queryForGet (page) {
  return { page }
}

function queryForGetAvailableTags (type) {
  return { type, hint: '' }
}

export function get (page, type) {
  // The news endpoint changes based on whether or not the user is an admin
  const fetchOpts = { credentials: 'include' }
  return apiFetch(`/${type}`, queryForGet(page), fetchOpts)
  .catch(always([]))
}

export function getSingleNews (id) {
  const fetchOpts = { credentials: 'include' }
  return apiFetch(`/news/${id}`, {}, fetchOpts)
  .catch(always([]))
}

export function getSingleEvent (id) {
  return apiFetch(`/events/${id}`)
  .catch(always([]))
}

export function getAvailableTags (type) {
  return apiFetch(`/storytag`, queryForGetAvailableTags(type))
  .catch(always([]))
}



// WEBPACK FOOTER //
// ./resources/assets/js/transport/story.js